import { Box, Card } from '@zillow/constellation-10';
import SkeletonContainer from '../SkeletonContainer';
import Bone from '../Bone';

export default function TourStatusCardSkeleton({ showStackedView = false }) {
  return (
    <SkeletonContainer>
      <Card
        elevated={false}
        css={{
          borderLeftWidth: '3px',
          borderLeftColor: 'gray.300',
          display: 'flex',
          flexDirection: 'column',
          flexFlow: 'column wrap',
          paddingLeft: 'loose',
          paddingRight: 'loose',
        }}
      >
        <Box>
          <Bone dark={true} type="line" />
        </Box>
        <Box css={{ marginTop: 'default' }}>
          <Bone dark={true} type="line" />
        </Box>
        {showStackedView && (
          <Box css={{ marginTop: 'default' }}>
            <Bone dark={true} type="line" />
          </Box>
        )}
      </Card>
    </SkeletonContainer>
  );
}
